"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EpicGamesNav = exports.NoBodyMargin = void 0;
const classnames_1 = __importDefault(require("classnames"));
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const navContext_1 = require("./context/navContext");
const navReducer_1 = require("./context/navReducer");
const pathname_1 = require("./context/pathname");
const EpicGamesNav_styles_1 = require("./EpicGamesNav.styles");
const EpicGamesNavInner_1 = require("./EpicGamesNavInner");
const shared_1 = require("./shared");
const bodyLocaleUtils_1 = require("./utils/bodyLocaleUtils");
const globalNavUtils_1 = require("./utils/globalNavUtils");
(0, globalNavUtils_1.initNavPreload)();
exports.NoBodyMargin = (0, styled_components_1.createGlobalStyle) `
    html, body {
        margin: 0;
    }
`;
const EpicGamesNav = (_a) => {
    var { locale = "en-US", epicPropertyClasses = "", theme, i18n, isHeaderPage, topOffset = 0, userAgent, LinkComponent, pathname } = _a, rest = __rest(_a, ["locale", "epicPropertyClasses", "theme", "i18n", "isHeaderPage", "topOffset", "userAgent", "LinkComponent", "pathname"]);
    (0, globalNavUtils_1.initBowser)(userAgent);
    const i18nContext = i18n || {};
    const navTheme = Object.assign(Object.assign({}, epic_games_nav_shared_1.defaultTheme), theme);
    (0, react_1.useEffect)(() => {
        (0, bodyLocaleUtils_1.setLocaleClassOnBody)(locale);
        (0, globalNavUtils_1.setUserAgent)();
        if (isHeaderPage) {
            Promise.resolve().then(() => __importStar(require("./observe/epicGamesNavObserver"))).then(globalNavUtils_1.initReadyChecks);
        }
        else {
            (0, globalNavUtils_1.initReadyChecks)();
        }
    }, [bodyLocaleUtils_1.setLocaleClassOnBody, globalNavUtils_1.setUserAgent, globalNavUtils_1.initReadyChecks]);
    const searchOpen = (0, shared_1.useSearchOpenStatic)();
    const headerClasses = (0, classnames_1.default)(epicPropertyClasses, locale.replace(/-/, "_"), { "search-open": searchOpen });
    const [state, dispatch] = (0, react_1.useReducer)(navReducer_1.navReducer, navContext_1.initialState);
    const finalLocale = i18nContext.locale || locale || "en-US";
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.NoBodyMargin, null),
        react_1.default.createElement(styled_components_1.ThemeProvider, { theme: navTheme },
            react_1.default.createElement(epic_games_nav_shared_1.LinkComponentContextProvider, { LinkComponent: LinkComponent },
                react_1.default.createElement(pathname_1.PathnameProvider, { pathname: pathname },
                    react_1.default.createElement(EpicGamesNav_styles_1.Header, { id: "egh", className: headerClasses },
                        react_1.default.createElement(EpicGamesNav_styles_1.Nav, { id: "nav", topOffset: topOffset },
                            react_1.default.createElement(epic_games_nav_shared_1.LocalizationProvider, { locale: finalLocale, messages: i18nContext.messages || {} },
                                react_1.default.createElement(navContext_1.NavContext.Provider, { value: { state, dispatch } },
                                    react_1.default.createElement(EpicGamesNavInner_1.EpicGamesNavInner, Object.assign({ topOffset: topOffset }, rest)))))))))));
};
exports.EpicGamesNav = EpicGamesNav;
//# sourceMappingURL=EpicGamesNav.js.map